module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/settings/parameters/parameters.component.css
// module id = ./src/app/components/settings/parameters/parameters.component.css
// module chunks = main